<template>
        <div class="container mt-3 container_products">
            <!-- عدد المنتجات -->
            <div class="d-flex justify-content-between align-items-center mb-3">
                <span> {{ $t('products') }}</span>

                <!-- أيقونات عرض الشبكة والقائمة -->

            </div>
            <!-- المسار (Breadcrumb) -->
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item active" aria-current="page">{{ $t('products') }}</li>
                </ol>
            </nav>

            <!-- تصنيفات المنتجات مع التمرير في الموبايل -->


            <div class=" mt-4">

                <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4  " id="grid">

                    <!-- المنتج الأول -->
                    <product_grid v-for="(item, index) in this.products" :key="index" :name="item.name"
                        :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                        :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                        :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer"
                        :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount"
                        :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
                        :range_price="item.range_price"></product_grid>



                </div>

                <!-- list-->

                <div class="container mt-4" id="list" style="display: none;">
                    <product_list v-for="(item, index) in this.products" :key="index" :name="item.name"
                        :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                        :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                        :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer"
                        :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount"
                        :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
                        :range_price="item.range_price"></product_list>
                </div>




                <!--  -->
            </div>
            <div class="col-lg-12 text-center paginate13">
                <nav aria-label="Page navigation example">

                    <b-pagination v-if="this.products.length != 0" v-model="page" :total-rows="count"
                        :per-page="this.paginate" :prev-text="$t('prev')" :next-text="$t('next')" pills size="sm"
                        class="paginate_theme13" @change="handlePageChange"></b-pagination>
                </nav>
            </div><!--end col-->


        </div>
    </template>
    <script>
   import product_grid from "../components/one_product_list.vue";
    
    export default {
      components: { product_grid},
      data() {
        return {
          loading: false,
          DBitems: null,
    
          sections: null,
          offers: null,
          products: null,
          loadingSections: false,
          loadingOffers: false,
          loadingProducts: false,
    
          pageSections: 1,
          allPageSections: 0,
         
          pageOffers: 1,
          allPageOffers: 0,
         
    
          pageProducts: 1,
          allPageProducts: 0,
        
    
          loadMoreIcon: false,
        };
      },
      watch: {
        "$route.params": {
          handler(newValue) {
            this.updatedata();
          },
          immediate: true,
        },
      },
      created() {

    
        //////////////////////sections//////////////////////
        if(this.$i18n.locale=='ar')
          {
          document.title = this.$store.state.title_ar;
          document.getElementById("description_meta").content=this.$store.state.description_ar;
          document.getElementById("keywords_meta").content=this.$store.state.keyword_ar;
          }
          else{
            document.title = this.$store.state.title_en;
          document.getElementById("description_meta").content=this.$store.state.description_en;
          document.getElementById("keywords_meta").content=this.$store.state.keyword_en;
          }
        //////////////////////sections//////////////////////
        this.loadingSections = true;
        this.axios
          .post(
            this.$store.state.base_api_url +
              this.$store.storeName +
              "/search_section",
            {
              word: this.$route.params.word,
            },
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
              },
            }
          )
          .then((response) => {
            this.sections = response.data.data.sections;
            this.allPageSections = response.data.meta.last_page;
            this.pageSizeSection=response.data.meta.per_page;
    
          })
          .then(() => (this.loadingSections = false));
    
        //////////////////////offers//////////////////////
        this.loadingOffers = true;
        this.axios
          .post(
            this.$store.state.base_api_url +
              this.$store.storeName +
              "/theme5/search_offer",
            {
              word: this.$route.params.word,
            },
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
              },
            }
          )
          .then((response) => {
            this.offers = response.data.data.offers;
            this.allPageOffers = response.data.meta.last_page;
            this.pageSizeOffers=response.data.meta.per_page;
    
            //this.countOffers = response.data.meta.total;
          })
          .then(() => (this.loadingOffers = false));
    
        //////////////////////products//////////////////////
        this.loadingProducts = true;
        this.axios
          .post(
            this.$store.state.base_api_url +
              this.$store.storeName +
              "/theme4/search_product",
            {
              word: this.$route.params.word,
            },
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
              },
            }
          )
          .then((response) => {
            this.products = response.data.data;
            this.allPageProducts = response.data.meta.last_page;
            //this.countProducts = response.data.meta.total;
            this.pageSizeProducts=response.data.meta.per_page;
    
          })
          .then(() => (this.loadingProducts = false));
      },
      methods: {
        updatedata() {
          //console.log("hooooooooooooooo");
          //////////////////////sections//////////////////////
          this.loadingSections = true;
          this.axios
            .post(
              this.$store.state.base_api_url +
                this.$store.storeName +
                "/search_section",
              {
                word: this.$route.params.word,
              },
              {
                headers: {
                  "Accept-Language": this.$i18n.locale,
                },
              }
            )
            .then((response) => {
              this.sections = response.data.data.sections;
            })
            .then(() => (this.loadingSections = false));
    
          //////////////////////offers//////////////////////
          this.loadingOffers = true;
          this.axios
            .post(
              this.$store.state.base_api_url +
                this.$store.storeName +
                "/search_offer",
              {
                word: this.$route.params.word,
              },
              {
                headers: {
                  "Accept-Language": this.$i18n.locale,
                },
              }
            )
            .then((response) => {
              this.offers = response.data.data;
            })
            .then(() => (this.loadingOffers = false));
    
          //////////////////////products//////////////////////
          this.loadingProducts = true;
          this.axios
            .post(
              this.$store.state.base_api_url +
                this.$store.storeName +
                "/theme4/search_product",
              {
                word: this.$route.params.word,
              },
              {
                headers: {
                  "Accept-Language": this.$i18n.locale,
                },
              }
            )
            .then((response) => {
              this.products = response.data.data;
            })
            .then(() => (this.loadingProducts = false));
    
          this.$store.state.langchange = false;
        },
        LoadMoreSections() {
          if (this.pageSections < this.allPageSections) {
            //this.loadingSections = true;
            this.loadMoreIcon = true;
            this.pageSections++;
            this.axios
              .post(
                this.$store.state.base_api_url +
                  this.$store.storeName +
                  "/search_section?page=" +
                  this.pageSections,
                {
                  word: this.$route.params.word,
                },
                {
                  headers: {
                    "Accept-Language": this.$i18n.locale,
                  },
                }
              )
              .then((response) => {
                for (let i = 0; i < response.data.data.sections.length; i++) {
                  this.sections.push(response.data.data.sections[i]);
                }
                this.loadMoreIcon = false;
              });
            //.then(() => (this.loadingSections = false));
          }
        },
     
        LoadMoreOffers() {
          if (this.pageOffers < this.allPageOffers) {
            this.loadMoreIcon = true;
            this.pageOffers++;
            this.axios
              .post(
                this.$store.state.base_api_url +
                  this.$store.storeName +
                  "/search_offer?page=" +
                  this.pageOffers,
                {
                  word: this.$route.params.word,
                },
                {
                  headers: {
                    "Accept-Language": this.$i18n.locale,
                  },
                }
              )
              .then((response) => {
                for (let i = 0; i < response.data.data.offers.length; i++) {
                  this.offers.push(response.data.data.offers[i]);
                }
                this.loadMoreIcon = false;
              });
          }
        },
        LoadMoreProducts() {
          if (this.pageProducts < this.allPageProducts) {
            this.loadMoreIcon = true;
            this.pageProducts++;
            this.axios
              .post(
                this.$store.state.base_api_url +
                  this.$store.storeName +
                  "/search_product?page=" +
                  this.pageProducts,
                {
                  word: this.$route.params.word,
                },
                {
                  headers: {
                    "Accept-Language": this.$i18n.locale,
                  },
                }
              )
              .then((response) => {
                for (let i = 0; i < response.data.data.products.length; i++) {
                  this.products.push(response.data.data.products[i]);
                }
                this.loadMoreIcon = false;
              });
          }
        },
      },
    };
    </script>
